module.exports = __webpack_public_path__ + "609af4b03f72bd440e707768e6d6b0ce.pdf";